export const SITE_URL = "https://www.loribooks.com/"
// export const SITE_URL = "https://eloquent-lamport-ea59fb.netlify.app/"